// import request from '@/utils/request'
import axios from '@/http/api'




//3.1.11 查询用户是否有操作流媒体服务的权限
export  const selectUserMediaInfo = data => {
  return axios({
    url:'/manageGateway/usersController/selectUserMediaInfo',
    method: 'post',
    data
  })
}

//3.8.11 获取用户组织集控树
export  const selectUserOrgEquipmentTree = data => {
  return axios({
    url:'/manageGateway/equipmentController/selectUserOrgEquipmentTree',
    method: 'post',
    data
  })
}

//selectUserOrgTree //3.2.12 获取用户组织流媒体树  返回终端的树
export const selectUserOrgTree = data => {
    return axios({
    url: '/manageGateway/organizationController/selectUserOrgTree',
    method: 'post',
    data
  })
}
//不返回终端的数
export const selectUserOrgMediaTree = data => {
  return axios({
    url: '/manageGateway/organizationController/selectUserOrgMediaTree',
    method: 'post',
    data
  })
}
//selectLowerOrgTreeByOrgId //获取下层组织机构
export const selectLowerOrgTreeByOrgId = data => {
  return axios({
    url: '/manageGateway/organizationController/selectLowerOrgTreeByOrgId',
    method: 'post',
    data
  })
}
//deleteOrganization //批量删除组织机构
export const deleteOrganization = data => {
  return axios({
    url: '/manageGateway/organizationController/deleteOrganization',
    method: 'post',
    data
  })
}

//insertOneOrg //添加组织机构
export const insertOneOrg = data => {
  return axios({
    url: '/manageGateway/organizationController/insertOneOrg',
    method: 'post',
    data
  })
}

//updateOrganization //修改组织机构信息
export const updateOrganization = data => {
  return axios({
    url: '/manageGateway/organizationController/updateOrganization',
    method: 'post',
    data
  })
}

//updateOrgOrder //修改组织机构排序//拖拽
export const updateOrgOrder = data => {
  return axios({
    url: '/manageGateway/organizationController/updateOrgOrder',
    method: 'post',
    data
  })
}
//selectOrgEntityByOrgId //修改单个组织机构信息
export const selectOrgEntityByOrgId = data => {
  return axios({
    url: '/manageGateway/organizationController/selectOrgEntityByOrgId',
    method: 'post',
    data
  })
}

//selectAgencyNumByOrgId //修改单个组织机构信息
export const selectAgencyNumByOrgId = data => {
  return axios({
    url: '/manageGateway/organizationController/selectAgencyNumByOrgId',
    method: 'post',
    data
  })
}
//selectOrgNum //获取组织机构代码
export const selectOrgNum = data => {
  return axios({
    url: '/manageGateway/organizationController/selectOrgNum',
    method: 'post',
    data
  })
}
//updateMediaState //更新组织流媒体状态
export const updateMediaState = data => {
  return axios({
    url: '/manageGateway/organizationController/updateMediaState',
    method: 'post',
    data
  })
}
export const selectMediaOrg = data => {
  return axios({
    url: '/manageGateway/organizationController/selectMediaOrg',
    method: 'post',
    data
  })
}







// WEBPACK FOOTER //
// ./src/api/organization.js